/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateReportScheduleRequest } from '../../models/create-report-schedule-request';
import { ReportScheduleDto } from '../../models/report-schedule-dto';

export interface ReportSchedulesPost$Json$Params {
      body?: CreateReportScheduleRequest
}

export function reportSchedulesPost$Json(http: HttpClient, rootUrl: string, params?: ReportSchedulesPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, reportSchedulesPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReportScheduleDto>;
    })
  );
}

reportSchedulesPost$Json.PATH = '/report-schedules';
